import React, { useEffect, useState } from 'react'
import { create } from 'axios'
import { API_URL } from '../config'
const axios = create()
const STORIES_URL = `${API_URL}storiesIVF.php`

function extractYouTubeId(url) {
    if (!url) return null
    const regex = /(?:youtube\.com\/(?:.*v=|v\/|embed\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/
    const m = url.match(regex)
    if (m && m[1]) return m[1]
    try {
        const u = new URL(url)
        return u.searchParams.get('v')
    } catch (e) {
        return null
    }
}

const SuccessStories = () => {
    const [videos, setVideos] = useState([])
    const [error, setError] = useState('')

    useEffect(() => {
        let mounted = true
        const load = async () => {
            try {
                const response = await axios.post(STORIES_URL, { action: 'list', status: 'Active' })
                const data = response.data?.data || response.data || []
                if (!mounted) return
                const items = Array.isArray(data) ? data : []
                // only include records with status === 'Active'
                const activeItems = items.filter((it) => String(it.status || '').toLowerCase() === 'active')
                const sliced = activeItems.slice(0, 6).map((it) => {
                    const link = it.storyLink || it.storylink || it.link || ''
                    const yt = extractYouTubeId(link)
                    return {
                        id: it.id ?? it.ID ?? null,
                        link,
                        yt,
                        description: it.description || it.desc || ''
                    }
                })
                setVideos(sliced)
            } catch (err) {
                console.error('Failed to load success stories', err)
                setError('Failed to load success stories')
            }
        }
        load()
        return () => { mounted = false }
    }, [])

    return (
        <section style={{ padding: '2rem 1rem' }}>
            <div style={{ maxWidth: 1200, margin: '0 auto', background: 'linear-gradient(135deg, #cccdd1e3 0%, #d7d7d7d0 100%)', color: '#121111', padding: '2rem', borderRadius: 8 }}>
                <h2 style={{ marginBottom: '1rem' }}>Success Stories</h2>
                {error && <p style={{ color: '#dc2626' }}>{error}</p>}
                <div style={{ display: 'flex', gap: '1rem', overflowX: 'auto', padding: '0.5rem 0' }}>
                    {videos.length === 0 && !error && (
                        <div style={{ color: '#64748b' }}>No stories available.</div>
                    )}

                    {videos.map((v, idx) => (
                        <div key={idx} style={{ minWidth: 250, width: 250, flex: '0 0 auto', borderRadius: 8, overflow: 'hidden', background: '#000' }}>
                            {/* {v.description && (
                                <div style={{ color: '#030303', background: 'rgba(255, 254, 254, 0.9)', padding: '0.75rem 0.9rem', fontSize: '0.95rem', lineHeight: 1.4 }}>
                                    {v.description}
                                </div>
                            )} */}
                            <div style={{ position: 'relative', width: '100%', height: 0, paddingBottom: '56.25%' }}>
                                {v.yt ? (
                                    <iframe
                                        title={`story-${idx}`}
                                        src={`https://www.youtube.com/embed/${v.yt}`}
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowFullScreen
                                        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                                    />
                                ) : (
                                    <a href={v.link || '#'} target="_blank" rel="noopener noreferrer" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 12, color: '#fff', textDecoration: 'none', background: '#000' }}>
                                        {v.link || 'View Story'}
                                    </a>
                                )}
                            </div>
                        </div>
                    ))}
                        </div >
            </div>
        </section>
    )
}

export default SuccessStories